module.exports = __webpack_public_path__ + "img/mesa-lado-de-fora.7e7a9c33.webp";